import React, { Component } from 'react'
import './videoImage.scss'
import YouTube from 'react-youtube';
import ReactGA from 'react-ga'

class VideoImage extends Component {

    constructor(props) {
        super(props);
        this.state = { playing: false };
    }

    videoControlClick = () => {
        if (this.props.youtubeId == null) {
            this.refs.videoRef.play();
        }

        this.setState({ playing: true });

        ReactGA.event({
            category: 'Video',
            action: `${this.refs.imageRef.alt} played`
        });
    }

    render() {
        let video = null;
        if (this.props.youtubeId != null) {
            video = <YouTube className={(this.state.playing ? "show-video" : "")} videoId={this.props.youtubeId} onReady={this._onReady}/>
          } else {
              video = <video id="content-creation-video" className="img-fluid" ref="videoRef" controls>
                        <source src={this.props.videoSrc} type="video/mp4" />
                      </video>
          }

        return (
            <div className="image-video">
              <img className={"img-fluid" + (this.state.playing ? " hide-image" : " show") + (this.props.youtubeId != null ?  " relative" : "")}
                src={this.props.imageSrc} ref="imageRef" alt={this.props.alt} />
                {video}
              <div className={"image-video-controls" + (this.state.playing ? " hide-image" : " show")} onClick={this.videoControlClick}>
                <div className="circle">
                  <i className="fas fa-play"></i>
                </div>
                <div className="play-title">Watch Video</div>
              </div>
            </div>
        )
    }
}

export default VideoImage;



// WEBPACK FOOTER //
// ./src/components/VideoImage/VideoImage.js